module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm.customerId
  }, [(_vm.products.length > 0) ? _c('table', {
    staticClass: "ui celled small very compact table center aligned productslist"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Image')))]), _vm._v(" "), _c('th', {
    staticClass: "six wide"
  }, [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Reference')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Tissu/Col/Poignets')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Combination')))]), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v(_vm._s(_vm.$t('Price')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Measure')))]), _vm._v(" "), _c('th', {
    staticClass: "two wide"
  }, [_vm._v(_vm._s(_vm.$t('Ops')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.products), function(product, index) {
    return _c('tr', {
      key: product.id,
      staticClass: "product"
    }, [_c('td', [(product.source != 'formens' && product.customizable != 0) ? _c('img', {
      attrs: {
        "alt": "Fabric",
        "src": 'http://www.cottonsociety.com/modules/cs_shirtgenerator/design/img/tissu/219/' +
          _vm.getParameter(product, 'TISSU').picture
      }
    }) : _c('img', {
      attrs: {
        "alt": "Product",
        "src": 'http://www.cottonsociety.com' +
          '/img/tmp/product_mini_' +
          product.id_product +
          '_1.jpg'
      }
    })]), _vm._v(" "), _c('td', [_c('p', [_vm._v(_vm._s(product.name))])]), _vm._v(" "), _c('td', [_c('div', {
      class: product.source
    }, [(product.source === 'customized') ? _c('span', [_vm._v("N/A")]) : _c('span', [_vm._v(_vm._s(product.reference))])])]), _vm._v(" "), _c('td', {
      staticClass: "ticopo"
    }, [(product.customizable != 0) ? _c('div', {
      staticClass: "customized"
    }, [_c('p', [_vm._v(_vm._s(_vm.getParameter(product, 'TISSU').name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getParameter(product, 'COLLAR').name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getParameter(product, 'CUFFS').name))])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "combination"
    }, [(product.customizable != 0) ? _c('div', [(_vm.showAttributes[index]) ? _c('i', {
      staticClass: "ui huge angle up icon",
      on: {
        "click": function($event) {
          return _vm.toggleshowAttributes(index)
        }
      }
    }) : _c('i', {
      staticClass: "ui huge angle down icon",
      on: {
        "click": function($event) {
          return _vm.toggleshowAttributes(index)
        }
      }
    }), _vm._v(" "), (_vm.showAttributes[index] && _vm.getParameterAll(product)) ? _c('table', {
      staticClass: "ui celled small very compact table center aligned attributes-table"
    }, [_c('tbody', _vm._l((_vm.getParameterAll(product)), function(attribute, idx) {
      return _c('tr', {
        key: idx
      }, [_c('td', [_vm._v("\n                    " + _vm._s( //group_id
        attribute.group_name) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s( //parameter_id, parameter_name, code, parameter_ps_attribute_name
        attribute.parameter_name) + "\n                  ")]), _vm._v(" "), _c('td', [(
        attribute.parameter_value_id ||
        attribute.parameter_value_text
      ) ? _c('span', [_c('span', {
        class: {
          'not-available': attribute.code == 'TISSU' && !_vm.availableFabrics[attribute.code]
        }
      }, [_vm._v("\n                        " + _vm._s( // parameter_value_id
        attribute.parameter_value_text || 'NOT SET'))])]) : (
        attribute.name == 'Initiales' ||
        attribute.code == 'DOUBLURETISSU'
      ) ? _c('span', {
        staticStyle: {
          "color": "darkorange"
        }
      }, [_vm._v("NOT SET\n                    ")]) : _c('span', {
        staticClass: "danger"
      }, [_vm._v("NOT SET")])])])
    }), 0)]) : _vm._e()]) : _c('div', [_c('table', {
      staticClass: "ui celled small very compact table left aligned presta-table"
    }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Product')))]), _vm._v(" "), _c('td', {
      class: product.source
    }, [_vm._v("\n                    " + _vm._s(product.id_product) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Combination')))]), _vm._v(" "), _c('td', {
      class: product.source
    }, [_vm._v("\n                    " + _vm._s(product.id_combination ||
      product.id_product_attribute ||
      product.product_attribute_id ||
      'N/A') + "\n                  ")])]), _vm._v(" "), _vm._l((Object.keys(
      product.attribute_list
    )), function(attribute_name, idx) {
      return _c('tr', {
        key: idx
      }, [_c('td', [_vm._v(_vm._s(attribute_name))]), _vm._v(" "), _c('td', {
        class: product.source
      }, [_vm._v("\n                    " + _vm._s(product.attribute_list[attribute_name]) + "\n                  ")])])
    }), _vm._v(" "), (product.source === 'formens') ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Original price')))]), _vm._v(" "), _c('td', {
      staticClass: "original-price"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("price")(product.original_product_price || product.presta_price)) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (product.source === 'formens') ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Suggested price')))]), _vm._v(" "), _c('td', {
      class: product.source
    }, [_vm._v("\n                    " + _vm._s(_vm._f("price")(product.fms_suggested_price || product.price)) + "\n                  ")])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('td', {
      staticClass: "price"
    }, [_vm._v(_vm._s(_vm._f("price")(product.price)))]), _vm._v(" "), _c('td', {
      staticClass: "measure"
    }, [(((product.source != 'formens' && product.customizable != 0) || product.source == 'order') && product.isShirt) ? _c('div', [(_vm.currentCustomer.measures.length > 0) ? _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (product.measure_id),
        expression: "product.measure_id"
      }],
      staticClass: "ui fluid dropdown selection",
      staticStyle: {
        "height": "40px"
      },
      attrs: {
        "placeholder": "Measure"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(product, "measure_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.currentCustomer.measures), function(measure) {
      return _c('option', {
        key: measure.id,
        domProps: {
          "value": measure.id
        }
      }, [_vm._v("\n                  " + _vm._s(measure.name) + "\n                  "), _c('br'), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "10px"
        }
      }, [_vm._v(_vm._s(measure.date_upd))])])
    }), 0)]) : _c('measure-modal', {
      on: {
        "create": function (measure) {
          _vm.products[index].measure_id =
            measure.id
        }
      }
    }, [_c('button', {
      ref: "measure_modal",
      refInFor: true,
      staticClass: "ui blue button",
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('i', {
      staticClass: "add icon"
    }), _vm._v(_vm._s(_vm.$t('Add measure')) + "\n              ")])])], 1) : (product.source == 'formens') ? _c('div', [_c('table', {
      staticClass: "ui celled small very compact table center aligned reference-table"
    }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Factory reference')))]), _vm._v(" "), _c('td', {
      class: product.source
    }, [_vm._v("\n                    " + _vm._s(product.fms_factory_reference || product.formens_ref) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Product type')))]), _vm._v(" "), _c('td', {
      class: product.source
    }, [_vm._v("\n                    " + _vm._s(product.fms_product_type || product.product_type) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Pattern base')))]), _vm._v(" "), _c('td', {
      class: product.source
    }, [_vm._v("\n                    " + _vm._s(product.fms_pattern_base || product.pattern_base) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Base size')))]), _vm._v(" "), _c('td', {
      class: product.source
    }, [_vm._v("\n                    " + _vm._s(product.fms_base_size || product.base_size) + "\n                  ")])])])])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "ops"
    }, [(product.source != 'formens' && product.customizable != 0 && product.isShirt) ? _c('button', {
      staticClass: "ui button icon green",
      attrs: {
        "title": "Edit this shirt"
      },
      on: {
        "click": function($event) {
          return _vm.openProductModal(product)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    })]) : _vm._e(), _vm._v(" "), (product.source != 'formens') ? _c('button', {
      staticClass: "ui button icon orange",
      attrs: {
        "title": "Clone this shirt"
      },
      on: {
        "click": function($event) {
          return _vm.cloneProduct(product)
        }
      }
    }, [_c('i', {
      staticClass: "clone icon"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "ui button icon red",
      attrs: {
        "title": "Delete this shirt"
      },
      on: {
        "click": function($event) {
          return _vm.openDeleteModal(product)
        }
      }
    }, [_c('i', {
      staticClass: "trash icon"
    })])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.intersectionOfFormensAndPrestaProducts.length > 0) ? _c('p', [_c('span', {
    staticClass: "danger"
  }, [_vm._v("*")]), _vm._v("\n    This cart has same product/combination\n    "), _c('span', {
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.intersectionOfFormensAndPrestaProducts))]), _vm._v("\n    from Prestashop search and Formens search. But they have different price\n    rules. Please remove the conflict products from either type to continue\n    order.\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "ui compact blue icon button left floated",
    on: {
      "click": function($event) {
        return _vm.addProduct()
      }
    }
  }, [_c('i', {
    staticClass: "add icon"
  }), _vm._v(_vm._s(_vm.$t('Add shirt')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "search-presta"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.keywordSearchPresta[_vm.customerId]),
      expression: "keywordSearchPresta[customerId]"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "name": "box-search-presta"
    },
    domProps: {
      "value": (_vm.keywordSearchPresta[_vm.customerId])
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchPrestashop()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.keywordSearchPresta, _vm.customerId, $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ui compact purple icon button",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.searchPrestashop()
      }
    }
  }, [_c('i', {
    staticClass: "search icon"
  }), _vm._v(_vm._s(_vm.$t('Search Prestashop')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "search-formens"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.keywordSearchFormens[_vm.customerId]),
      expression: "keywordSearchFormens[customerId]"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "name": "box-search-formens"
    },
    domProps: {
      "value": (_vm.keywordSearchFormens[_vm.customerId])
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchFormens()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.keywordSearchFormens, _vm.customerId, $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ui compact pink icon button",
    on: {
      "click": function($event) {
        return _vm.searchFormens()
      }
    }
  }, [_c('i', {
    staticClass: "search icon"
  }), _vm._v(_vm._s(_vm.$t('Search B2B')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "ready-to-pay-message"
  }, [_vm._v("\n      " + _vm._s(_vm.readyToPayMessage) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "ui green icon button right floated",
    attrs: {
      "disabled": !_vm.readyToPay
    },
    on: {
      "click": function($event) {
        return _vm.openCartModal()
      }
    }
  }, [_c('i', {
    staticClass: "cart icon"
  }), _vm._v(_vm._s(_vm.$t('Pay')) + "\n    ")])]), _vm._v(" "), _c('found-products', {
    key: _vm.customerId,
    attrs: {
      "customer-id": _vm.customerId,
      "show": _vm.showSearch[_vm.customerId],
      "searching": _vm.searching[_vm.customerId],
      "keyword": _vm.keywordSearchPresta[_vm.customerId],
      "category": _vm.category[_vm.customerId],
      "found-products": _vm.foundProducts[_vm.customerId],
      "current-page": _vm.currentPage[_vm.customerId]
    },
    on: {
      "changePageSize": _vm.changePageSize,
      "changePage": _vm.changePage
    }
  }), _vm._v(" "), _c('formens-modal', {
    ref: "formensModal",
    staticClass: "formens-modal",
    attrs: {
      "formens-product": _vm.currentFormensProduct,
      "user": _vm.user
    },
    on: {
      "close": _vm.closeFormensModal,
      "addToCart": _vm.addFromFormensToCart
    }
  }), _vm._v(" "), _c('product-modal', {
    ref: "productModal"
  }), _vm._v(" "), _c('order-modal', {
    ref: "orderModal",
    on: {
      "switchToOrdersTab": function($event) {
        return _vm.$emit('switchToOrdersTab')
      }
    }
  }), _vm._v(" "), _c('popup-modal', {
    attrs: {
      "index": _vm.product_to_delete,
      "icon": "checkmark",
      "cancel_class": "ui red basic cancel inverted button",
      "confirm_class": "ui green ok inverted button",
      "text": "Are you sure you want to delete this shirt ?"
    },
    on: {
      "cancel": function($event) {
        _vm.product_to_delete = null
      },
      "delete": _vm.deleteProduct
    }
  }), _vm._v(" "), _c('popup-modal', {
    attrs: {
      "index": _vm.product_to_update,
      "icon": "checkmark",
      "cancel_class": "ui red basic cancel inverted button",
      "confirm_class": "ui green ok inverted button",
      "text": "Formens product with this factory reference already exists in cart, are you sure to update it?"
    },
    on: {
      "cancel": function($event) {
        _vm.product_to_update = null
      },
      "delete": function($event) {
        return _vm.updateFormensProductInCart()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-019fff6c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tabs/CartTab.vue
// module id = 476
// module chunks = 1